import type { AdminCapability } from 'common/models/admin/rbac';

export interface AdminNavChild {
  label: string;
  to: string;
}

export interface AdminNavItem {
  label: string;
  to: string;
  requires?: AdminCapability;
  children?: AdminNavChild[];
}

export const adminNavItems: AdminNavItem[] = [
  { label: 'Dashboard', to: '/' },
  {
    label: 'Analytics',
    to: '/analytics',
    requires: 'analytics:view',
    children: [
      { label: 'Overview', to: '/analytics' },
      { label: 'Sessions', to: '/analytics/sessions' },
      { label: 'Product', to: '/analytics/product' },
    ],
  },
  {
    label: 'Organizations',
    to: '/organizations',
    requires: 'org:view',
    children: [
      { label: 'Active Orgs', to: '/organizations' },
      { label: 'Deleted Orgs', to: '/organizations/deleted' },
    ],
  },
  {
    label: 'Fleet',
    to: '/fleet',
    requires: 'fleet:view',
    children: [
      { label: 'Overview', to: '/fleet' },
      { label: 'Tasks', to: '/fleet/tasks' },
      { label: 'Regions', to: '/fleet/regions' },
      { label: 'Trends', to: '/fleet/trends' },
    ],
  },
  { label: 'Test runs', to: '/test-runs', requires: 'test-runs:view' },
  { label: 'Users', to: '/users', requires: 'user:view' },
];

export function visibleNavItems(can: (capability: AdminCapability) => boolean): AdminNavItem[] {
  return adminNavItems.filter((item) => !item.requires || can(item.requires));
}
